/**
 * 模块挂载时间上报
 * 1. 仅对路由组件生效
 * 2. 通过 performance.getEntriesByType('resource') 获取模块加载的 script 资源明细
 */

import { getRenderMenuId } from 'public/utils/menu-id.js'
import { isRouteComponent, isReport, getModuleOpenTime, getModuleName, reportOnIdle } from './utils.js'

// 大于2000的才上报
const MODULE_MOUNT_THRESHOLD = 2000

// 根据开始时间和结束时间，从performance.getEntries()里打出这个时间段中，所有关于script的性能明细
const getScriptPerformanceDetails = (startTime, endTime) => {
  const entries = performance.getEntriesByType('resource')
  const timeOrigin = performance.timeOrigin
  return entries.filter(entry => {
    return (
      entry.initiatorType === 'script' &&
      entry.startTime >= startTime - timeOrigin &&
      entry.startTime <= endTime - timeOrigin
    )
  })
}

const report = (menuId, moduleName, mountedTime, openTime, scriptLoadDetails) => {
  const message = `模块挂载时间上报: 耗时=${mountedTime - openTime}, moduleName=${moduleName} , mountedTime=${mountedTime} , openTime=${openTime}  menuId=${menuId} `
  // console.info(message, scriptLoadDetails)
  window.aplus_queue && window.aplus_queue.push({
    'action': 'aplus.record',
    'arguments': ['erp_common_resource', 'OTHER', {
      message,
      detail: JSON.stringify(scriptLoadDetails)
    }]
  })
}

export default {
  mounted() {
    try {
      if (!isReport()) {
        return
      }

      const vm = this
      if (isRouteComponent(vm)) {
        const menuId = getRenderMenuId(vm)
        const moduleOpenTime = getModuleOpenTime(menuId)
        const moduleMountedTime = Date.now()
        const moduleName = getModuleName(vm.$store, menuId)
        const scriptLoadDetails = getScriptPerformanceDetails(moduleOpenTime, moduleMountedTime)
        if (moduleMountedTime - moduleOpenTime < MODULE_MOUNT_THRESHOLD) {
          return
        }

        reportOnIdle(
          () => {
            report(menuId, moduleName, moduleMountedTime, moduleOpenTime, scriptLoadDetails)
          }
        )
      }
    } catch (error) {
      console.error('模块挂载时间上报失败', error)
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/mixins/module-mounted-report/index.js